// Kalaburagi (Gulbarga) neighborhoods — keys must match backend NEIGHBORHOODS.
export const AREAS = [
  "City Centre",
  "Super Market",
  "Sedam Road",
  "Ring Road",
  "Jewargi Road",
  "Aiwan-e-Shahi",
  "Brahmpur",
  "University Area",
  "Naya Mohalla",
  "MSK Mill",
  "Station Area",
  "Gubbi Colony",
];
